import React, { FC } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserIcon from "../../static/svg/UserIcon";
import DetailsIcon from "../../static/svg/DetailsIcon";
import MainLayout from "../../Layouts/MainLayout";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";

const CrewConfiguration = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();


    const handleClick = (path: string, state?: any) => {
    
        navigate(path, { state });
      
    };

    const tiles = [

    
          { name: 'Users', path: `/user-page/crew/${id}`, icon: UserIcon },
          { name: "Details", path: `/crew_detail/${id}`, icon: DetailsIcon },
    ]

  const content = (
    <div className="All-cards p-3">
    {tiles.map((tile, index) => (
      <div
        key={index}
        onClick={() => handleClick(tile.path)}
        style={{ cursor: "pointer" }}
      >
        <div className="assigned_tiles_inner activate">
          {typeof tile.icon === "string" ? (
            <img src={tile.icon} alt={tile.name} />
          ) : (
            <tile.icon />
          )}
          <div className="tile mt-3">{tile.name}</div>
        </div>

      </div>
    ))}
  </div>
  )

  const handleAdd = () => {};

  return (
    <>
      <MainLayout>
        <SectionHeader back={true} title={"Crew: Configurations"}></SectionHeader>
        <WindowHeightComponent className={""}>
            {content}
            </WindowHeightComponent>
      </MainLayout>
    </>
  );
};
export default CrewConfiguration;
